const styles = {
    profileLable: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '21px',
        color: '#8697AB',
        marginBottom: '8px',
    },
    profileValue: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '21px',
        color: '#001533',
        marginBottom: '24px',
        overflowWrap: 'break-word',
        whiteSpace: 'break-spaces',
    },
    editUser: {
        background: '#3876AA',
        borderRadius: '16px',
        width: '287px',
        margin: '0px 24px',
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '21px',
        color: '#FFFFFF',
        textAlign: 'center',
    },
    sendResetLink: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '21px',
        color: '#3876AA',
        textAlign: 'center',
    },
    container: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
    },
    name: {
        textTransform: 'Capitalize',
    },
    continue: {
        fontFamily: 'Silka_Semi_Bold',
        fontSize: '16px',
        lineHeight: '8px',
        textAlign: 'center',
        borderRadius: 2,
        p: 2,
        color: 'white',
        textTransform: 'none',
        backgroundColor: '#ED0000',
    },
    cancel: {
        fontFamily: 'Silka_Semi_Bold',
        fontSize: '16px',
        lineHeight: '16px',
        textAlign: 'center',
        borderRadius: 2,
        p: 2,
        color: '#3876AA',
        textTransform: 'none',
        mr: 2,
        borderWidth: '2px',
    },
};
export default styles;
